var map = {
	"./1000+.png": 162,
	"./404.png": 163,
	"./BookReader.png": 164,
	"./Booknet.png": 165,
	"./BravoFiction.png": 166,
	"./CamelNovel.png": 167,
	"./Chapters.png": 168,
	"./CoralReader.png": 169,
	"./CornReading.png": 170,
	"./DailyBooks.png": 171,
	"./DeerFiction.png": 172,
	"./DolphinReader.png": 173,
	"./Dreams.png": 174,
	"./FICTLF.png": 175,
	"./FancyNovel.png": 176,
	"./FicFun.png": 177,
	"./FicWorld.png": 178,
	"./FictionFlow.png": 179,
	"./FoxFics.png": 180,
	"./FoxFm.png": 181,
	"./Free2Read.png": 182,
	"./FreeRead.png": 183,
	"./FunFic.png": 184,
	"./FunNovel.png": 185,
	"./FunStory-android.png": 186,
	"./Gonovel.png": 187,
	"./GoodFiction.png": 188,
	"./GoodStory.png": 189,
	"./GoodToon.png": 190,
	"./GrapeNovel.png": 191,
	"./HeyRead.png": 192,
	"./HippoNovel.png": 193,
	"./HitNovel.png": 194,
	"./Hitfic.png": 195,
	"./HotNovel.png": 196,
	"./IHear.png": 197,
	"./Inkspired.png": 198,
	"./Inkwell.png": 199,
	"./KiWiReader.png": 200,
	"./Kiwi.png": 201,
	"./LemonRead.png": 202,
	"./LetsRead.png": 203,
	"./Libfic.png": 204,
	"./Liby-android.png": 205,
	"./Liby.png": 206,
	"./LionFiction.png": 207,
	"./Listenow.png": 208,
	"./LoveNovel.png": 209,
	"./LoveRead.png": 210,
	"./Mango.png": 211,
	"./MangoReader.png": 212,
	"./Mebooks.png": 213,
	"./Mobooks.png": 214,
	"./Monkey.png": 215,
	"./MyNovel.png": 216,
	"./Mylib.png": 217,
	"./NovelFox.png": 218,
	"./NovelHut.png": 219,
	"./NovelNow.png": 220,
	"./NovelPro.png": 221,
	"./NovelWorld.png": 222,
	"./NovelZone.png": 223,
	"./Octopus.png": 224,
	"./OrangeReader.png": 225,
	"./OwlReader.png": 226,
	"./PocketFic.png": 227,
	"./PocketeBooks.png": 228,
	"./PocketeReader.png": 229,
	"./Pocketoons.png": 230,
	"./Podfic.png": 231,
	"./PopFic.png": 232,
	"./PopNovel.png": 233,
	"./PopStories.png": 234,
	"./Pumpkin.png": 235,
	"./Rabbit.png": 236,
	"./Read4Fun-ios.png": 237,
	"./Read4Fun.png": 238,
	"./ReadNow.png": 239,
	"./Readify.png": 240,
	"./Readme.png": 241,
	"./Seagull.png": 242,
	"./Sealread.png": 243,
	"./SharkNovels.png": 244,
	"./Shepherd.png": 245,
	"./SnailReads.png": 246,
	"./StarfishFiction.png": 247,
	"./StoryHouse.png": 248,
	"./StoryRover.png": 249,
	"./StorySphere.png": 250,
	"./StorySpot.png": 251,
	"./SuperFiction.png": 252,
	"./SuperNovel.png": 253,
	"./Sweet.png": 254,
	"./TaleTrek.png": 255,
	"./TapRead.png": 256,
	"./Tellstory.png": 257,
	"./TigerReader.png": 258,
	"./Tomato.png": 259,
	"./TopFic.png": 260,
	"./Topicks.png": 261,
	"./UniFic.png": 262,
	"./VampireNovels.png": 263,
	"./WeJoy.png": 264,
	"./WeRead.png": 265,
	"./Webfiction.png": 266,
	"./Webfm.png": 267,
	"./Webnovel.png": 268,
	"./Webstories.png": 269,
	"./Whatstory.png": 270,
	"./about_bg.png": 271,
	"./android-FicFun.png": 272,
	"./appStore-check.png": 273,
	"./appStore.png": 56,
	"./app_logo.png": 120,
	"./application.png": 274,
	"./banner.png": 275,
	"./banner1.png": 276,
	"./banner2.png": 277,
	"./banner3.png": 278,
	"./basic.png": 279,
	"./bg-game.png": 280,
	"./bg.png": 281,
	"./book.png": 282,
	"./bottom-icon.png": 283,
	"./cherryfiction.png": 284,
	"./close.png": 285,
	"./contact_bg.png": 286,
	"./crazyapp.png": 287,
	"./desc.png": 288,
	"./down (1).png": 289,
	"./down.png": 290,
	"./e1.png": 291,
	"./e2.png": 292,
	"./e3.png": 293,
	"./eAudioBooks.png": 294,
	"./eReader-logo.png": 295,
	"./ereader.png": 296,
	"./fancyNovel-android.png": 297,
	"./ficfun-logo.png": 298,
	"./fj.png": 299,
	"./form_bg.png": 300,
	"./funtel-logo.png": 301,
	"./funtel.png": 302,
	"./goodfic.png": 303,
	"./goodficapp.png": 304,
	"./googlePlay-check.png": 305,
	"./googlePlay.png": 57,
	"./greatnovel.png": 306,
	"./i1.png": 307,
	"./i2.png": 308,
	"./i3.png": 309,
	"./iAudios.png": 310,
	"./iComics.png": 311,
	"./iFiction.png": 312,
	"./iNovel-ios.png": 313,
	"./iNovel.png": 314,
	"./iRomance.png": 315,
	"./iToons.png": 316,
	"./icon.png": 317,
	"./infinitytale.png": 318,
	"./iosGoodStory.png": 319,
	"./iosgoodfiction.png": 320,
	"./left.png": 321,
	"./litchifiction.png": 322,
	"./logo.png": 323,
	"./logo2.png": 324,
	"./logo3.png": 325,
	"./logo4.png": 326,
	"./logo5.png": 327,
	"./m-tel.png": 328,
	"./more.png": 329,
	"./pandareads.png": 330,
	"./peanutnovel.png": 331,
	"./phone.png": 121,
	"./pocketEbook.png": 332,
	"./qiandao.png": 333,
	"./redfic.png": 334,
	"./right.png": 335,
	"./right_bg.png": 336,
	"./romancestories.png": 337,
	"./storyfm.png": 338,
	"./theme3/shu.png": 122,
	"./theme4/banner.png": 123,
	"./theme4/people.png": 124,
	"./topstories.png": 339,
	"./ty.png": 340,
	"./web-logo.png": 341,
	"./werewolfnovels.png": 342,
	"./whatsread.png": 343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;